import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useModal } from 'components/modals/ModalContext';
import TicketChat from './TicketChat';
import TicketSidePanel from './TicketSidePanel';
import { useTicketActions } from './useTicketActions';
import { useTicketConversation } from './useTicketConversation';

interface TicketConversationModalProps {
    itemId?: number;
    refetchList?: () => void;
}

// The conversation of a single ticket with its side column in a modal, opened from the ticket lists
const TicketConversationModal: React.FC<TicketConversationModalProps> = ({ itemId, refetchList }) => {
    const history = useHistory();
    const { revealModal, closeModal } = useModal();
    const { ticket, messages, tasks, loadStatus, refresh } = useTicketConversation(itemId);

    // Reveal the modal once the ticket is loaded
    useEffect(() => {
        if (loadStatus === 'loaded') revealModal();
        // eslint-disable-next-line
    }, [loadStatus]);

    // Refresh the conversation and the list behind the modal after a change
    const handleRefresh = () => {
        refresh();
        refetchList?.();
    };

    // The delete and switch requester actions of the more menu, a deleted ticket closes the modal
    const { onDelete, onSwitchReporter, onCreateProposal, onCreateJob, onCreateDeal, onStartTimer } = useTicketActions({
        ticketId: itemId ?? null,
        ticket,
        onDeleted: () => { closeModal(); refetchList?.(); },
        onChanged: handleRefresh,
    });

    // Close the modal and open the ticket in the service desk view
    const handleOpenInServicedesk = () => {
        closeModal();
        history.push(`/tickets/${itemId}`);
    };

    // Render nothing until the ticket is loaded
    if (!ticket) return null;

    return (
        <div className='ticket-chat-modal'>
            <TicketChat ticket={ticket} messages={messages} tasks={tasks} onRefresh={handleRefresh}
                        onSwitchReporter={onSwitchReporter} onDelete={onDelete} onOpenInServicedesk={handleOpenInServicedesk}
                        onCreateProposal={onCreateProposal} onCreateJob={onCreateJob} onCreateDeal={onCreateDeal} onStartTimer={onStartTimer} />
            <TicketSidePanel ticket={ticket} loadStatus={loadStatus} refetchData={handleRefresh} />
        </div>
    );
};

export default TicketConversationModal;
